import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Input,
  Text,
  Stack,
  Select,
} from "@chakra-ui/react";
import Modal_lib_teacher_sidebar_table from "./Modal_lib_teacher_sidebar_table";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Library_Staff_Return = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null); // For selected book data to show in modal

  const [borrowedBooks, setBorrowedBooks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState(false);

  const schoolId = sessionStorage.getItem("school_id"); // Get the school ID
  const staffId = sessionStorage.getItem("staff_id"); // Use the staff ID

  // Fetch borrowed books
  useEffect(() => {
    const fetchMemberIdAndBorrowedBooks = async () => {
      try {
        const schoolId = sessionStorage.getItem("school_id");
        const staffId = sessionStorage.getItem("staff_id");

        // Fetch member_id from membership API
        const membershipResponse = await axios.get(
          `${BASE_URL}/staff/library/t_membership_details.php?school_id=${schoolId}&staff_id=${staffId}`
        );
        console.log("member", membershipResponse);

        if (
          membershipResponse.data.success &&
          membershipResponse.data.data &&
          membershipResponse.data.data.member_id
        ) {
          const memberId = membershipResponse.data.data.member_id;
          console.log("membr", memberId);

          // Fetch borrowed books using member_id
          const booksResponse = await axios.get(
            `${BASE_URL}/admin/library/issues/borrowed_books.php?school_id=${schoolId}&member_id=${memberId}`
          );
          console.log("book norrow", booksResponse);

          if (
            booksResponse.data.success &&
            booksResponse.data.data.length > 0
          ) {
            setBorrowedBooks(booksResponse.data.data);
          } else {
            setError("No book taken from library.");
          }
        } else {
          setError("No membership details found.");
        }
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setError("No data found.");
        } else {
          setError("An error occurred while fetching data.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMemberIdAndBorrowedBooks();
  }, []);
  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/library/category/list_category.php?school_id=${schoolId}`
        );

        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch categories");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching categories");
      }
    };

    if (schoolId) {
      fetchCategories();
    }
  }, [schoolId]);

  const filteredBooks = borrowedBooks.filter((book) => {
    const matchesCategory =
      !selectedCategory || book.category === selectedCategory;
    const matchesSearch =
      !searchQuery ||
      book.title.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredBooks.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredBooks.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBook(null);
  };
  const handleOpenModal = (book) => {
    setSelectedBook(book);
    setIsModalOpen(true);
  };
  if (loading) {
    return <div>Loading...</div>;
  }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  return (
    <Box overflowX="auto" bg="#FBFBFD">
      <div className="teacher-list-container">
        <div className="header">
          <h1 style={{ fontSize: "20px", margin: 0 }}>Books</h1>
        </div>

        <div className="breadcrumb">
          <Text as="span">Dashboard</Text> /{" "}
          <Text as="span">Library-Staff</Text>
        </div>

        <Box mt={5}>
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align="center"
            mb={1}
            p={3}
            className="sb"
          >
            {/* Rows Per Page */}
            <Flex align="center" mb={{ base: 4, md: 0 }}>
              <Text mr={2}>Rows Per Page</Text>
              <Select
                width="120px"
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
              </Select>
            </Flex>

            {/* Search and Filters on the Right */}
            <Flex
              direction={{ base: "column", md: "row" }}
              align="center"
              ml={{ md: "auto" }}
            >
              <Flex align="center" mb={{ base: 4, md: 0 }} mr={{ md: 4 }}>
                <Select
                  // width="200px"
                  width={{ base: "280px", md: "200px" }}
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <option value="">All Categories</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.name}>
                      {category.name}
                    </option>
                  ))}
                </Select>
              </Flex>
              <Flex align="center">
                <Input
                  width={{ base: "280px", md: "200px" }}
                  placeholder="Search by Book Name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box overflowX="auto" maxWidth="100%">
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
            >
              <Thead>
                <Tr>
                  <Th>Book Title</Th>
                  <Th>Due Date</Th>

                  <Th>Fine Date</Th>
                  <Th>Fine Amount</Th>
                  <Th>Payment Mode</Th>
                  <Th>Paid</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentData.map((book) => (
                  <Tr key={book.id}>
                    <Td>{book.title}</Td>
                    <Td>{book.due_date}</Td>

                    <Td>
                      {book.fine_date
                        ? new Date(book.fine_date).toLocaleDateString()
                        : "N/A"}
                    </Td>
                    <Td>{book.fine_amount ? `$${book.fine_amount}` : "N/A"}</Td>
                    <Td>{book.payment_mode || "N/A"}</Td>
                    <Td>{book.paid ? "Yes" : "No"}</Td>
                    <Td>
                      {/* Add the condition to show the Pay button */}
                      {book.status === "Returned" &&
                        book.fine_amount !== null &&
                        book.paid === 0 && (
                          <Button
                            colorScheme="blue"
                            size="xs"
                            alignSelf="flex-end"
                            mt={4}
                            onClick={() => {
                              handleOpenModal();
                              setData(book);
                            }}
                          >
                            Pay
                          </Button>
                        )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          {isModalOpen && (
            <Modal_lib_teacher_sidebar_table
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              last={data ? data.due_date : ""}
              memberId={data.member_id}
              fineeId={data.fine_id}
              staffId={data.staff_id}
              totalAmount={data.fine_amount}
              TeacherLedgerId={data.teacher_ledger_id}
            />
          )}
          <Flex justify="end" borderTopWidth="1px" p={3} className="sb2">
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
              mr={2}
            >
              Prev
            </Button>
            <Stack direction="row" spacing={2} mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
              ml={2}
            >
              Next
            </Button>
          </Flex>
        </Box>
      </div>
    </Box>
  );
};

export default Library_Staff_Return;
